import {useEffect, useState} from 'react';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { PhoneInput, defaultCountries, parseCountry, buildCountryData } from 'react-international-phone';
import { removeEmojis } from '@/utils/filterEmojis';

// El formato de react-international-phone para Argentina limita los números del
// interior (prefijos 2,3,4,5) a 9 dígitos locales con la máscara "(.) .... ....".
// Los números móviles del interior tienen 10 dígitos (ej: 264 + 4823042), por lo
// que el campo los truncaba y nunca pasaban la validación. Se actualiza la máscara
// a "(.) .... ....." (10 dígitos), igual que el formato usado para prefijo 9.
const customCountries = defaultCountries.map((country) => {
    const parsed = parseCountry(country);
    if (parsed.iso2 === 'ar') {
        return buildCountryData({
            ...parsed,
            format: {
                ...parsed.format,
                '/^(2|3|4|5)/': '(.) .... .....',
            },
        });
    }
    return country;
});

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone, defaultCountry) => {
  try {
    const number = phoneUtil.parseAndKeepRawInput(phone, defaultCountry.toUpperCase());
    if (phoneUtil.isValidNumber(number)) return true;

    if (defaultCountry.toUpperCase() === 'AR') {
      const withMobilePrefix = phone.replace(/^\+54(?!9)/, '+549');
      const mobileNumber = phoneUtil.parseAndKeepRawInput(withMobilePrefix, 'AR');
      return phoneUtil.isValidNumber(mobileNumber);
    }

    return false;
  } catch (error) {
    return false;
  }
};

const InputPhone = ({ name, onChange, country_short_name }) => {

  const [phone, setPhone] = useState('');
  const [defaultCountry, setDefaultCountry] = useState(country_short_name.toLowerCase());

  const countries = customCountries.filter((country) => {
    const { iso2 } = parseCountry(country);
    return [country_short_name.toLowerCase()].includes(iso2);
  });

    useEffect(() => {
        setDefaultCountry(country_short_name.toLowerCase());
    }, [country_short_name]);

  const handlePhoneChange = (phone) => {
    const filteredPhone = removeEmojis(phone);
    const isValid = isPhoneValid(filteredPhone, defaultCountry);
    setPhone(filteredPhone);
    if (onChange) {
      onChange({ target: { name, value: filteredPhone, isValid }, country: defaultCountry });
    }
  };

  const handleCountryChange = (country) => {
    setDefaultCountry(country.iso2.toUpperCase());
    handlePhoneChange(phone);
  };

  return (
      <PhoneInput
          forceDialCode="true"
          defaultCountry={defaultCountry}
          disableFormatting="true"
          value={phone}
          onChange={handlePhoneChange}
          onCountryChange={handleCountryChange}
          countries={countries}
      />
  );
};

export default InputPhone;
